import { render, staticRenderFns } from "./HomeClinic.vue?vue&type=template&id=a2d99e66&"
import script from "./HomeClinic.vue?vue&type=script&lang=js&"
export * from "./HomeClinic.vue?vue&type=script&lang=js&"
import style0 from "./HomeClinic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports